export enum AppRoutes {
  // common
  NOT_FOUND = '/404',
  VERIFY_USER = '/auth/verify-user/:token',
  VERIFY = '/auth/verify/:token', // VERIFY_USER should be used, but not updated on backend yet

  // auth
  LOGIN = '/auth/login',
  REGISTER = '/auth/register',
  CHECK_YOUR_EMAIL_REGISTER = '/auth/register/check-your-email',
  RESET_PASSWORD = '/auth/reset-password',
  RESET_PASSWORD_TOKEN = '/auth/reset-password/:token',
  CHECK_YOUR_EMAIL_RESET_PASSWORD = '/auth/reset-password/check-your-email',

  // organizations
  ORGANIZATIONS = '/organizations',
  ORGANIZATIONS_DETAILS = '/organizations/:id',
  ORGANIZATION_CREATE = '/organizations/create',

  // domains
  DOMAINS = '/domains',

  HOME = '/',

  // user
  USERS = '/users',
  USER_ACCOUNTS = '/users/accounts',
  USER_ACCOUNT_DETAILS = '/users/accounts/:id',
  USER_PROFILE_DETAILS = '/users/profile/:id',
  USER_ME = '/users/profile/me',
  USER_INVITATIONS = '/users/user-invitations',
  USER_MANAGED_CREATE = '/users/create-managed-user',

  // invitation
  INVITATION_DETAILS = '/invitations/:id',
  INVITATION_ACCEPTANCE = 'auth/user-invitations/:id',

  CHANGE_PASSWORD = '/user/change-password',
  // role
  ROLES = 'users/roles',
  ROLE_DETAILS = 'users/roles/:id',

  // permission
  PERMISSIONS_MY = '/permissions/my',

  // forms
  FORMS = '/forms',
  FORMS_BROWSE = '/forms/browse/:id',
  FORMS_DYNAMIC_DETAILS = '/forms/dynamic/:id',
  FORMS_DYNAMIC_CREATE = '/forms/dynamic/:form_id/create',
  FORMS_DETAILS = '/forms/:id',
  FORMS_CREATE = '/forms/create',

  // Modules/Services
  HRM = '/hrm',
}
